"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const react_1 = require("react");
const useShortenedLink = (url, accessToken) => {
    const [shortenedLink, setShortenedLink] = (0, react_1.useState)(url);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const shortenLink = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!url || !accessToken) {
                setError(new Error("URL or access token is missing."));
                return;
            }
            try {
                const response = yield axios_1.default.post("https://api-ssl.bitly.com/v4/shorten", { long_url: url }, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                });
                setShortenedLink(response.data.link);
            }
            catch (error) {
                setError(error);
            }
        });
        shortenLink();
    }, [url, accessToken]);
    return { shortenedLink, error };
};
exports.default = useShortenedLink;
